import axiosInstance from '../../config/axios';

const XML_EXPORT_PATH = '/sap/export';

// Wraps the eSAP XML export storage endpoints (POST /api/sap/export/save,
// GET /api/sap/export/:projectId, GET /api/sap/export/detail/:id). Each save
// is a new version in the project's series - versionNumber is computed
// server-side, never supplied by the caller.
//
// Uses the shared axiosInstance (not a bare axios.create()) specifically
// because /save needs it: its request interceptor attaches the session's
// Bearer token, which the server's optionalAuth middleware decodes into
// req.user so the Document Service push can resolve who is exporting. A bare
// axios call here would send no token at all, and the push would silently
// skip every time ("User null has no hubId").
const sapXmlExportService = {
  saveXmlExport: async (projectId, { filename, xmlContent, sectionCount } = {}) => {
    try {
      const response = await axiosInstance.post(`${XML_EXPORT_PATH}/save`, {
        projectId,
        filename,
        xmlContent,
        sectionCount,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getAllXmlExports: async (projectId) => {
    try {
      const response = await axiosInstance.get(`${XML_EXPORT_PATH}/${projectId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getXmlExportById: async (exportId) => {
    try {
      const response = await axiosInstance.get(`${XML_EXPORT_PATH}/detail/${exportId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default sapXmlExportService;
